import { atom, selector } from 'recoil';
import { getKssData } from '../../util/kssData';
import { getUserData } from '../../api/auth';
import { getFeedbackValuesData } from '../../api/user';
import { getCardsData } from '../../api/session';

export const userSelector = selector({
    key: 'userSelector',
    get: () => {
        const teamId = localStorage.getItem('team-id');

        return getUserData(null, teamId);
    },
});

export const userAtom = atom({
    key: 'userAtom',
    default: userSelector,
});

export const userForAdminPanelSelector = selector({
    key: 'userForAdminPanelSelector',
    get: () => {
        const userForAdminPanelId = localStorage.getItem('user-id-for-admin-panel');
        const teamId = localStorage.getItem('team-id');

        if (userForAdminPanelId) {
            return getUserData(+userForAdminPanelId, teamId);
        }

        return {};
    },
});

export const userForAdminPanelAtom = atom({
    key: 'userForAdminPanelAtom',
    default: userForAdminPanelSelector,
});

export const userKssTrackerDataForAdminPanelSelector = selector({
    key: 'userKssTrackerDataForAdminPanelSelector',
    get: () => {
        return getCardsData()
            .then(({ data: kss }) => {
                if (!kss.length) {
                    return [];
                }

                if (!kss) {
                    return [null, null, null];
                }

                const getItemByStatus = (status) => kss.filter((i) => i.status === status)[0];
                return [getItemByStatus('keep'), getItemByStatus('stop'), getItemByStatus('start')];
            })
            .catch((err) => {
                console.error('Ошибка при получении KSS', err);
                return [];
            });
    },
    set: ({ set }, newData) => {
        set(userKssTrackerDataForAdminPanelAtom, newData);
    },
});

export const userKssTrackerDataForAdminPanelAtom = atom({
    key: 'userKssTrackerDataForAdminPanelAtom',
    default: userKssTrackerDataForAdminPanelSelector,
});

export const userValuesForAdminPanelSelector = selector({
    key: 'userValuesForAdminPanelSelector',
    get: () => {
        return getFeedbackValuesData().then(({ data }) => data.values);
    },
    set: ({ set }, newData) => {
        set(userValuesForAdminPanelAtom, newData);
    },
});

export const userValuesForAdminPanelAtom = atom({
    key: 'userValuesForAdminPanelAtom',
    default: userValuesForAdminPanelSelector,
});

export const userKssDataForAdminPanelSelector = selector({
    key: 'userKssDataForAdminPanelSelector',
    get: getKssData,
    set: ({ set }, newData) => {
        set(userKssDataForAdminPanelAtom, newData);
    },
});

export const userKssDataForAdminPanelAtom = atom({
    key: 'userKssDataForAdminPanelAtom',
    default: [],
});

export const userValuesAtom = atom({
    key: 'userValues',
    default: [],
});

export const userSessionTeamAtom = atom({
    key: 'userSessionTeam',
    default: [],
});

export const kssDataSelector = selector({
    key: 'kssDataSelector',
    get: getKssData,
    set: ({ set }, newData) => {
        set(kssDataAtom, newData);
    },
});

export const kssDataAtom = atom({
    key: 'kssDataAtom',
    default: kssDataSelector,
});
